// modules/Stageplan.js
import React from 'react';
import $                from 'jquery';
import PlanDisplay      from './elements/PlanDisplay';
import PlanButton        from './elements/PlanButton';
import BackButton       from '../common/BackButton';
import { browserHistory, Link } from 'react-router';
import SiteDownloads    from '../common/SiteDownloads';
import PageLoading      from '../PageLoading';
import LandSearchBar	from './elements/LandSearchBar';
import LandSearchListItem from './elements/LandSearchListItem';
import LandAssortedGridItem from './elements/LandAssortedGridItem';


import Messenger        from '../common/Messenger';
let messenger 			= new Messenger();

let sources = require('../config.json');

class Stageplan extends React.Component {
	constructor(props) {
		super(props);
		this.stageplan_url = sources.stageplan + '/' + this.props.params.stage;

		this.state = {
			data: {
				plan: {},
				downloads: [],
				elements: [],
				stages: []
			},
			available: []
		};

		this.receivedStageplanData  = this.receivedStageplanData.bind(this);
		this.planDisplay      		= this.planDisplay.bind(this);
		this.eachStageButton = this.eachStageButton.bind(this);
		this.eachDownloadButton = this.eachDownloadButton.bind(this);
        this.onSearchClick      		= this.onSearchClick.bind(this);
        this.onStageSelect = this.onStageSelect.bind(this);
	}

	componentDidMount() {
		$.ajax({url:this.stageplan_url,dataType:'json'}).done(this.receivedStageplanData);
	}

    componentWillReceiveProps(newProps) {
		let newState = Object.assign(this.state, {
            data: {
                plan: {},
                downloads: [],
                elements: [],
                stages: []
            },
            available: []
        });
        this.setState(newState);
        $.ajax({url: sources.stageplan + '/' + newProps.params.stage,dataType:'json'}).done(this.receivedStageplanData);
	}

    onSearchClick(frontage, land, url) {
        url = url + '?frontage='+frontage.start+'&frontage='+frontage.end+'&land='+land.start+'&land='+land.end;
        browserHistory.push(url);
    }

	receivedStageplanData(data, status, xhr) {
		let available = this.filterLots(data.elements,sources.activestatus);

		if(typeof data.plan === 'undefined') data.plan = [];
		if(typeof data.downloads === 'undefined') data.downloads = [];
		if(typeof data.elements === 'undefined') data.elements = [];

		let newState = Object.assign(this.state, {
			data: data,
			available: available
		});

		this.setState(newState);
        /*document.getElementById('reloadScroll').scrollIntoView();*/
        document.body.scrollTop = 0; // For Chrome, Safari and Opera
        document.documentElement.scrollTop = 0; // For IE and Firefox
	}
	filterLots(elements,type) {
        return elements.reduce(function (accum, current) {
			if ( type.indexOf(current.status) !== -1 )
				accum.push(current);
			return accum;
		}, []);
	}

    eachStageButton(element) {
        if (element.length !== 0) {
            return (
				<PlanButton activePath={this.props.location.pathname} key={element.id} id={null} messenger={messenger} buttonlink={element.link} buttonclass={element.class} lotCountTxt={this.lotsAvailableText(element.lot_count)}>{element.name}</PlanButton>
            )
        } else {
            return null;
        }
    }

    eachDownloadButton(element) {
        if (element.length !== 0) {
            return (
				<li className="p-a-1 brd-top no-hov" key={element.download_id}>
					<div className="btn__container tc tl-md">
						<a className="btn btn__action--rev w-100" href={element.download_pdf} target="_blank">
							<i className="icon icon--download"></i><span>{element.download_title}</span></a>
					</div>
				</li>
            )
        }
	}

	planDisplay() {
        if(this.state.data.plan.plan_name === "Titled & Assorted Lots" && typeof this.state.data.plan.plan_id !== "undefined") {
            return (
                this.state.data.elements.map((lot) => {
                	if(parseInt(lot.status, 10) !== 2) { return ( <LandAssortedGridItem data={lot} key={lot.id}/> ) } else { return ( null ) }
                })
			)
        }
		if (typeof this.state.data.plan.plan_id !== "undefined") {
			return (
				<PlanDisplay key={this.state.data.plan.plan_id} messenger={messenger} plan={this.state.data.plan} elements={this.state.data.elements} plantype="stageplan">stage plan</PlanDisplay>
			)
		}
        return null;
	}

	lotsAvailableText(lots) {
		if (lots > 0) {
			if(lots === 1) {
				return '1 lot'
			} else {
				return lots +' lots';
			}
		} else {
			return 'Sold Out'
		}

	}

    onStageSelect(ev) {
		console.log('stageSelect:');
		console.log(ev);
		if(this.props.location.pathname !== ev.target.value) {
            browserHistory.push(ev.target.value);
        }
	}

	render() {
		if (typeof this.state.data.plan.plan_id !== "undefined") {
            return (
				<div className="App">
                    <div id="reloadScroll"></div>
					<section className="section p-t-2">
						<div className="container">
							<div className="section__content tc">
								<h1 className="title f3 f4-md f-headline-lg m-b-1 m-b-2-md">Land For Sale</h1>
								<LandSearchBar onSearchClick={this.onSearchClick} onResetClick={null} search={this.props.location.query} divClass="filter release__filter js-accordion open mobile-hide"/>
								<div className="w-100 db dn-lg release-sort-dd">
									<div className="sortby-release">
										<select value={this.props.location.pathname} onChange={this.onStageSelect}>
											<option>Release:</option>
											{this.state.data.stages.map( (stage) =>
												<option key={stage.id} value={stage.link} >{stage.name}</option>
											)}
										</select>
									</div>
								</div>
							</div>
						</div>
					</section>
					<section className="section p-h-1 p-h-3-lg section-bg-white land-filter-section">
						<div className="container">
							<div className="cf top-land-filter-section  m-b-3-lg m-b-1">
								<div className="w-100 mobile-hide">
									<BackButton/>
									<div className="fr p-h-1-md p-t-0 p-b-1 f6 w-90-md w-100 tr-md tl">
											<p className="dib m-b-0-md m-b-1 m-r-1 tc">Stage Key:</p>
											<br className="br br-n-md"/>
											<span className="stage-key legend-avail dib"></span>
											<p className="dib m-b-0-md m-b-05 m-r-1">Land Available</p>
											<span className="stage-key legend-sold dib"></span>
											<p className="dib m-b-0 m-r-1">Land Sold</p>
											<br className="br br-n-md"/>
											<span className="stage-key legend-excul dib"></span>
											<p className="dib m-b-0 m-r-1">Builder Exclusive</p>
											<span className="stage-key legend-hold dib"></span>
											<p className="dib m-b-0">Land On Hold</p>
									</div>
									<div className="cf"></div>
								</div>

								<div className="w-100 w-70-lg fr-lg">{this.planDisplay()}</div>
								<div className="w-100 w-30-lg fr-lg mobile-hide">
									<p className="m-b-0 p-a-1 brd-top small-blue-font tc tl-md">
										<Link className="small-blue-font tc tl-md" to={this.state.data.parent.parent_link}>{this.state.data.parent.parent_name}</Link>
									</p>
									<ul className="">
										{this.state.data.stages.map(this.eachStageButton)}
										{this.state.data.plan.plan_name !== "Titled & Assorted Lots" ? this.state.data.downloads.map(this.eachDownloadButton) : null}
									</ul>
								</div>
							</div>
							<SiteDownloads divClass="cf p-a-1 btm-land-filter-section m-b-3-lg m-b-1 mobile-hide"/>
							<div className="cf top-land-filter-search m-b-3-lg m-b-1">
								<div className="w-100">
									<p className="m-b-0 p-a-1 release-title tc tl-md">{this.state.data.plan.plan_name}</p>
									<ul className="">
										{this.state.data.elements.map((lot) =>
											<LandSearchListItem data={lot} key={lot.id}/>
										)}
									</ul>
								</div>
							</div>
							<SiteDownloads divClass="cf p-a-1 btm-land-filter-section m-b-3-lg m-b-1 db dn-lg"/>
						</div>
					</section>
				</div>
            );
		} else {
			return (
				<PageLoading>Stage</PageLoading>
			)
		}
	}
}

export default Stageplan;


/** WEBPACK FOOTER **
 ** ./src/modules/land-for-sale/Stageplan.js
 **/